import { object, SchemaOf, string } from 'yup';

import { CustomerLookupOutput } from '@/graphql/contracts/_generated_/contracts';


export type Fields = {
  divertPaymentName?: CustomerLookupOutput | null;
  divertPaymentAccountNumber?: CustomerLookupOutput | null;

};

export const validationSchema: SchemaOf<Fields> = object().shape({
  divertPaymentName: object().shape({
    customerName: string(),
    customerAccountNumber: string(),
    customerID: string()
  })
    .test((value, context) => {
      const currentCustomerId = context?.parent?.currentCustomer?.customerID;
      const currentParentId = context?.parent?.currentCustomer?.parentCustomer?.customerID;
      const customerOrParentSelected = value?.customerID === currentCustomerId || value?.customerID === currentParentId;
      
      if (value && customerOrParentSelected) {
        return context.createError({
          path: 'divertPaymentName',
          message: 'Divert customer cannot be existing customer or parent customer'
        });
      }
      return true;
    })
    .nullable(),
  divertPaymentAccountNumber: object().shape({
    customerName: string(),
    customerAccountNumber: string(),
    customerID: string()
  })
    .test((value, context) => {
      const currentCustomerId = context?.parent?.currentCustomer?.customerID;
      const currentParentId = context?.parent?.currentCustomer?.parentCustomer?.customerID;
      const customerOrParentSelected = value?.customerID === currentCustomerId || value?.customerID === currentParentId;
      if (value && customerOrParentSelected) {
        return context.createError({
          path: 'divertPaymentAccountNumber',
          message: 'Divert customer cannot be existing customer or parent customer'
        });
      }
      return true;
    })

    .nullable(),
});
